import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRoles, homePathForRole } from './appRoles';

/** Paths couriers may access (customer marketplace is blocked). */
export const COURIER_ALLOWED_PREFIXES = [
  '/courier',
  '/login',
  '/language',
  '/help-support',
  '/terms',
  '/privacy',
  '/security',
] as const;

export function isCourierUser(role?: string | null) {
  return String(role || '').toLowerCase() === AppRoles.Courier;
}

export function isCourierAllowedPath(pathname: string) {
  return COURIER_ALLOWED_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

/** Redirect couriers away from customer marketplace routes. */
export function CourierRouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const role = localStorage.getItem('userType');
    if (!isCourierUser(role)) return;
    if (isCourierAllowedPath(location.pathname)) return;
    navigate(homePathForRole(AppRoles.Courier), { replace: true });
  }, [location.pathname, navigate]);

  return null;
}
